import {createContext} from "react";

export const SubscribingStateContext = createContext({});
